import { DataTableEmptyCell } from "@bcc/components/data-table";
import { Badge } from "@bcc/components/ui/badge";
import type { PurchaseOrder } from "@shared/types";
import type { CellContext } from "@tanstack/react-table";
import { ORDER_SHIP_TO_COUNTRY_CELL_TEST_IDS } from "./order-ship-to-country-cell.utils";

export const OrderShipToCountryCell = (props: CellContext<PurchaseOrder, unknown>) => {
  const address = props.row.original.shippingAddress;
  const display = address?.countryCode ?? address?.country;

  if (!display) return <DataTableEmptyCell />;

  return (
    <Badge
      variant="outline"
      className="bg-blue-100 text-blue-700 border-blue-300 dark:bg-blue-950 dark:text-blue-400 dark:border-blue-800 px-2.5 py-1 text-xs font-semibold hover:bg-blue-50 dark:hover:bg-blue-900"
      data-testid={ORDER_SHIP_TO_COUNTRY_CELL_TEST_IDS.container}
    >
      {display}
    </Badge>
  );
};
